import React from 'react';
import HomeSectionTitle from "../../HomeSectionTitle";
import  {config} from "../../../config";
import {Text} from "../../Text";
import { Parallax } from 'react-parallax';
import "./Locations.scss";


const Locations = ({sectionTitle, txt, poster, parallaxLayers}) => {

	const parallaxBg = parallaxLayers[0].parallax_layer;
	const parallaxLayer = parallaxLayers[1].parallax_layer;

	return (
		<div className="locations boxed" id="locations">
			<div className="row">
				<div className="col col-xs-12  col-md-6 locations__textbox" >
					<div className="row">
						<div className="col col-xs-12 locations__textbox__title">
							<HomeSectionTitle text={sectionTitle}/>
						</div>
						<div className="col col-xs-12 locations__textbox__txt">
							<div dangerouslySetInnerHTML={{__html: txt}} />
							<Text
								code="zobacz_wiecej_lokacji"
								tag="a"
								className="btn__primary"
								href={config.domainRelPath+"/locations"}
								title="Link: Locations"
								target="_top"
							/>
						</div>
					</div>
				</div>
				<div className="col col-xs-12 col-md-6 locations__poster" >
					{poster ?
						<img src={poster} alt={"Cover: " + sectionTitle}/> :
						<Parallax bgImage={parallaxBg} bgImageAlt="Your partner in crime" strength={80}>
							<div className="your-partner__content">
								<img
									src={parallaxLayer}
									alt={"Cover: " + sectionTitle}
									width={800}
									height={827}
								/>
							</div>
						</Parallax>
					}
				</div>

			</div>
		</div>
	);
};

export default Locations;